import { render, staticRenderFns } from "./BlockListItem.vue?vue&type=template&id=05c022ea&scoped=true"
import script from "./BlockListItem.vue?vue&type=script&lang=js"
export * from "./BlockListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c022ea",
  null
  
)

export default component.exports